import { useState } from "react";
import { useDispatch } from "react-redux";

import { editField } from "../../../redux";
import zips from "../../../utils/zips";

const useTransferTree = (featureNumber = 0) => {
  const dispatch = useDispatch();
  const [searchValRight, setSearchValRight] = useState("");
  const [searchValLeft, setSearchValLeft] = useState("");
  const [selected, setSelected] = useState([]);
  const [left, setLeft] = useState(zips);
  const [right, setRight] = useState([]);

  const intersection = (list) =>
    list.filter((item) => selected.includes(`${item.zip}`));

  const not = (a = [], b = []) => a.filter((value) => b.indexOf(value) === -1);

  const leftChecked = intersection(left);
  const rightChecked = intersection(right);

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setSelected([]);
    setSearchValLeft("");
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setSelected([]);
    setSearchValRight("");
  };

  const handleApply = () => {
    const appliedItem = right.map((item) => +item.zip);
    return dispatch(
      editField(
        `root[${featureNumber}].targeting.zip`,
        Array.from(
          new Set([...appliedItem].filter((item) => item !== undefined))
        )
      )
    );
  };

  const handleClearAll = () => {
    setLeft(zips);
    setRight([]);
    return dispatch(editField(`root[${featureNumber}].targeting.zip`, []));
  };

  return {
    right,
    left,
    leftChecked,
    rightChecked,
    searchValRight,
    setSearchValRight,
    searchValLeft,
    setSearchValLeft,
    selected,
    setSelected,
    handleCheckedRight,
    handleCheckedLeft,
    handleApply,
    handleClearAll,
  };
};

export default useTransferTree;
